export default __webpack_public_path__ + "static/media/logo-banner-img1.6162de54.jpg";